import {useQuery} from '@tanstack/react-query'

import {buildFieldMetricsQueryKey} from './query-keys'
import type {FieldMetricsQueryData} from './types'
import {usePaginatedMemexItemsQueryVariables} from './use-paginated-memex-items-query-variables'

export function useFieldMetricsQuery() {
  const variables = usePaginatedMemexItemsQueryVariables()
  const query = useQuery({
    queryKey: buildFieldMetricsQueryKey(variables),
    enabled: false,
    queryFn: (): FieldMetricsQueryData => {
      // We don't expect to use this queryFn, but by providing it we can
      // properly type the data returned by this query.
      return {groups: {}}
    },
  })

  return query
}
